import { useCallback, useState } from 'react';

export function useQobuzPlaylistRefresh() {
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);
  const [importProgress, setImportProgress] = useState(null);
  const [importJoinedInFlight, setImportJoinedInFlight] = useState(false);

  const handleRefreshPlaylists = useCallback(async () => {
    if (importing) return;
    setImporting(true);
    setImportResult(null);
    setImportProgress(null);
    setImportJoinedInFlight(false);
    try {
      const {
        runQobuzPlaylistImport,
        isQobuzPlaylistImportInFlight,
        formatPlaylistImportCompletionLine,
      } = await import('../services/qobuzPlaylistImport');
      if (isQobuzPlaylistImportInFlight()) {
        setImportJoinedInFlight(true);
      }
      const progress = await runQobuzPlaylistImport({
        mode: 'force',
        onProgress: (p) => setImportProgress(p),
      });
      setImportResult({
        ...progress,
        completionLine: formatPlaylistImportCompletionLine(progress),
      });
    } catch (err) {
      setImportResult({
        error: err?.message || 'Import failed',
        done: true,
        imported: 0,
        updated: 0,
        skippedUserEdited: 0,
        skippedUnchanged: 0,
        playlistsProcessed: 0,
        totalFound: 0,
        completionLine: err?.message || 'Import failed',
      });
    } finally {
      setImporting(false);
      setImportProgress(null);
      setImportJoinedInFlight(false);
    }
  }, [importing]);

  return {
    importing,
    importResult,
    importProgress,
    importJoinedInFlight,
    handleRefreshPlaylists,
  };
}
